import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { NewElectricityConnectionPage, NewElectricityConnectionPageProps } from "./NewElectricityConnectionPage";

export const EMPTY_PAGE_CONTENT: NewElectricityConnectionPageProps = {
  pageTitle: "",
};

const CANONICAL_LINK = "/personal/electricity/new-connection";

export const NewElectricityConnectionPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<NewElectricityConnectionPageProps>("new_electricity_connections", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <NewElectricityConnectionPage {...routeProps} {...content} />;
};
